/**
 * Toggle mappa / elenco per .contentlist.mappa_depositi (solo mobile ≤991px).
 * Inietta i pulsanti via JS — nessuna modifica all'HTML del template.
 */
const MOBILE_MQ = "(max-width: 991.98px)";

function createToggleButton(view, label, isActive) {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "cf-map-view-toggle__btn" + (isActive ? " is-active" : "");
    button.dataset.view = view;
    button.setAttribute("aria-label", label);
    button.setAttribute("aria-pressed", isActive ? "true" : "false");

    const icon = document.createElement("span");
    icon.className = "cf-map-view-toggle__icon";
    icon.setAttribute("aria-hidden", "true");

    if (view === "map") {
        icon.innerHTML =
            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
            '<path d="M2.5 6L6.5 4V15L2.5 17V6Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
            '<path d="M6.5 4L10 6.5V17.5L6.5 15V4Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
            '<path d="M10 6.5L13.5 4V15L10 17.5V6.5Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
            '<path d="M13.5 4L17.5 6V17L13.5 15V4Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
            "</svg>";
    } else {
        icon.innerHTML =
            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M4 6H16M4 10H16M4 14H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
            "</svg>";
    }

    button.appendChild(icon);
    return button;
}

function initMappaDepositiBlock(block, mq) {
    if (block.dataset.cfMapViewInit === "true") {
        return;
    }

    const searchBar = block.querySelector(".section-location .cf-search-bar");

    if (!searchBar || searchBar.closest(".section-location__search-row")) {
        return;
    }

    const toggle = document.createElement("div");
    toggle.className = "cf-map-view-toggle";
    toggle.setAttribute("role", "group");
    toggle.setAttribute("aria-label", "Visualizza mappa o elenco sedi");

    const btnMap = createToggleButton("map", "Mostra mappa", false);
    const btnList = createToggleButton("list", "Mostra elenco", true);

    toggle.appendChild(btnMap);
    toggle.appendChild(btnList);

    const searchRow = document.createElement("div");
    searchRow.className = "section-location__search-row";
    searchBar.parentNode.insertBefore(searchRow, searchBar);
    searchRow.appendChild(searchBar);
    searchRow.appendChild(toggle);

    block.dataset.cfMapViewInit = "true";

    function setView(view) {
        const isMap = view === "map";

        block.classList.toggle("cf-location-view--map", isMap);
        block.classList.toggle("cf-location-view--list", !isMap);

        btnMap.classList.toggle("is-active", isMap);
        btnList.classList.toggle("is-active", !isMap);
        btnMap.setAttribute("aria-pressed", isMap ? "true" : "false");
        btnList.setAttribute("aria-pressed", !isMap ? "true" : "false");

        if (isMap) {
            block.dispatchEvent(new CustomEvent("cf-mappa-depositi-show-map"));
            window.requestAnimationFrame(function () {
                window.dispatchEvent(new Event("resize"));
            });
        }
    }

    function applyMqState() {
        if (!mq.matches) {
            block.classList.remove("cf-location-view--map", "cf-location-view--list");
            toggle.hidden = true;
            return;
        }

        toggle.hidden = false;
        setView("list");
    }

    btnMap.addEventListener("click", function () {
        setView("map");
    });

    btnList.addEventListener("click", function () {
        setView("list");
    });

    mq.addEventListener("change", applyMqState);
    applyMqState();
}

/**
 * Su 3_landing, in mobile il form esce dall'aside e va sotto la contentlist mappa.
 * Desktop: torna nella colonna laterale originale.
 */
function initLandingFormAfterMap(mq) {
    const layout = document.querySelector(".layout-main-aside[data-mobile-form-after-map]");
    if (!layout || document.body.classList.contains("editing")) {
        return;
    }

    const aside = layout.querySelector(":scope > .layout-main-aside__aside");

    if (!aside) {
        return;
    }

    const originalParent = aside.parentNode;
    const originalNext = aside.nextSibling;

    function currentMap() {
        return layout.querySelector(".contentlist.mappa_depositi")
            || document.querySelector(".layout-map-first .contentlist.mappa_depositi");
    }

    function sync() {
        const mapBlock = currentMap();
        if (!mapBlock) {
            return;
        }
        if (mq.matches) {
            if (mapBlock.nextElementSibling !== aside) {
                mapBlock.after(aside);
            }
            aside.classList.add("layout-main-aside__aside--after-map");
            return;
        }

        aside.classList.remove("layout-main-aside__aside--after-map");
        if (aside.parentNode !== originalParent || aside.nextSibling !== originalNext) {
            originalParent.insertBefore(aside, originalNext);
        }
    }

    mq.addEventListener("change", sync);
    sync();

    const mapRoot = document.querySelector(".layout-map-first") || layout;
    if (window.MutationObserver) {
        const observer = new MutationObserver(function () {
            sync();
        });
        observer.observe(mapRoot, { childList: true, subtree: true });
    }
}

function normalizeStoreText(value) {
    return String(value || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, " ")
        .trim();
}

function branchJsonUrl() {
    const lang = String(document.documentElement.lang || "IT")
        .split("-")[0]
        .toUpperCase();
    return "/application/tools/branch_" + lang + "_.json";
}

function getDepositoSelect() {
    const root = document.getElementById("preventivo") || document;
    const selects = root.getElementsByTagName("select");

    for (let i = 0; i < selects.length; i += 1) {
        if (selects[i].name === "lead[deposito]") {
            return selects[i];
        }
    }

    return null;
}

function allowedCodesFromCards(cards) {
    const codes = [];

    cards.forEach(function (card) {
        const code = String(card.getAttribute("data-crm-id") || "").trim();
        if (code && codes.indexOf(code) === -1) {
            codes.push(code);
        }

        const button = card.querySelector(".js-select-store");
        if (button && code && !button.getAttribute("data-crm-id")) {
            button.setAttribute("data-crm-id", code);
        }
    });

    return codes;
}

function uniqueAreas(records) {
    const areas = [];

    records.forEach(function (record) {
        const area = String(record.area || "").trim();
        if (area && areas.indexOf(area) === -1) {
            areas.push(area);
        }
    });

    return areas;
}

function matchAreaName(text, areas) {
    const normalized = normalizeStoreText(String(text || "").replace(/-/g, " "));
    if (!normalized) {
        return "";
    }

    let i;
    for (i = 0; i < areas.length; i += 1) {
        if (normalizeStoreText(areas[i]) === normalized) {
            return areas[i];
        }
    }

    for (i = 0; i < areas.length; i += 1) {
        const areaName = normalizeStoreText(areas[i]);
        if (areaName.length >= 4 && normalized.indexOf(areaName) !== -1) {
            return areas[i];
        }
    }

    return "";
}

function areaFromPath(pathname, records) {
    const path = String(pathname || "").toLowerCase();
    const areas = uniqueAreas(records);
    let slug = "";
    let match = path.match(/landing-depositi-aziende-([a-z0-9-]+)/);

    if (match) {
        slug = match[1];
    } else {
        match = path.match(/\/landing-depositi-([a-z0-9-]+)\/?$/);
        if (match) {
            slug = match[1];
        }
    }

    if (slug === "italia" || slug === "self-storage-italia") {
        return "";
    }

    if (slug) {
        return matchAreaName(slug, areas);
    }

    if (/casaforte-per-/.test(path)) {
        if (/politecnico-di-milano|studenti-bocconi|community-unimi|bocconi|unimi/.test(path)) {
            return matchAreaName("milano", areas);
        }

        return matchAreaName(path.replace(/[^a-z0-9]+/g, " "), areas);
    }

    return "";
}

function codesForArea(records, area) {
    const normalized = normalizeStoreText(area);
    const codes = [];

    records.forEach(function (record) {
        if (normalizeStoreText(record.area) !== normalized) {
            return;
        }

        const code = String(record.code || "").trim();
        if (code && codes.indexOf(code) === -1) {
            codes.push(code);
        }
    });

    return codes;
}

function filterDepositoSelect(select, allowedCodes) {
    if (!select || !allowedCodes || !allowedCodes.length) {
        return false;
    }

    const keep = {};
    allowedCodes.forEach(function (code) {
        keep[code] = true;
    });

    const options = Array.prototype.slice.call(select.options);
    const hasAllowed = options.some(function (option) {
        return option.value && keep[option.value];
    });

    if (!hasAllowed) {
        return false;
    }

    let removed = false;
    options.forEach(function (option) {
        if (option.value && !keep[option.value]) {
            option.parentNode.removeChild(option);
            removed = true;
        }
    });

    if (!removed && select.getAttribute("data-landing-stores-filtered") === "1") {
        const preferred = select.getAttribute("data-cf-selected-store") || "";
        if (preferred && keep[preferred] && select.value !== preferred) {
            select.value = preferred;
        }
        return true;
    }

    if (select.value && !keep[select.value]) {
        select.value = "";
    }

    const preferred = select.getAttribute("data-cf-selected-store") || "";
    if (preferred && keep[preferred]) {
        select.value = preferred;
    }

    select.setAttribute("data-landing-stores-filtered", "1");
    select.dispatchEvent(new Event("change", { bubbles: true }));
    return true;
}

function selectDepositoCode(code) {
    const select = getDepositoSelect();
    if (!select || !code) {
        return false;
    }

    const hasOption = Array.prototype.some.call(select.options, function (option) {
        return option.value === code;
    });

    if (!hasOption) {
        return false;
    }

    select.value = code;
    select.setAttribute("data-cf-selected-store", code);

    if (window.jQuery) {
        window.jQuery(select).val(code).trigger("change");
    } else {
        select.dispatchEvent(new Event("input", { bubbles: true }));
        select.dispatchEvent(new Event("change", { bubbles: true }));
    }

    return select.value === code;
}

function headerScrollOffset() {
    const header = document.querySelector("header.site-header");
    const height = header ? header.getBoundingClientRect().height : 0;
    return Math.max(0, Math.round(height));
}

function getPreventivoTitle() {
    return (
        document.getElementById("form-quote-title") ||
        document.querySelector("#preventivo .form-quote__title") ||
        document.getElementById("preventivo")
    );
}

function scrollToPreventivo() {
    const target = getPreventivoTitle();
    if (!target) {
        return;
    }

    const top =
        target.getBoundingClientRect().top + window.pageYOffset - headerScrollOffset();
    window.scrollTo({
        top: Math.max(0, top),
        behavior: "smooth",
    });
}

function highlightDepositoSelect() {
    const select = getDepositoSelect();
    if (!select) {
        return;
    }

    select.classList.remove("cf-deposito-highlight");
    void select.offsetWidth;
    select.classList.add("cf-deposito-highlight");

    window.setTimeout(function () {
        select.classList.remove("cf-deposito-highlight");
    }, 900);
}

function afterPreventivoScroll(callback) {
    let done = false;
    const started = Date.now();
    const maxWait = 1100;
    const target = getPreventivoTitle();

    const finish = function () {
        if (done) {
            return;
        }
        done = true;
        callback();
    };

    function tick() {
        if (done) {
            return;
        }

        const offset = headerScrollOffset();
        const top = target ? target.getBoundingClientRect().top : offset;
        if (Math.abs(top - offset) <= 6 || Date.now() - started >= maxWait) {
            finish();
            return;
        }

        window.requestAnimationFrame(tick);
    }

    window.requestAnimationFrame(tick);
    window.setTimeout(finish, maxWait);
}

function watchDepositoSelect(allowedCodes) {
    function apply() {
        const select = getDepositoSelect();
        if (select) {
            filterDepositoSelect(select, allowedCodes);
        }
    }

    apply();

    const root = document.getElementById("preventivo") || document.body;
    const observer = new MutationObserver(function () {
        apply();
    });

    observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["data-tp-options-loaded"],
    });

    let attempts = 0;
    const timer = window.setInterval(function () {
        attempts += 1;
        apply();

        const select = getDepositoSelect();
        if (
            attempts >= 40 ||
            (select && select.getAttribute("data-landing-stores-filtered") === "1")
        ) {
            window.clearInterval(timer);
        }
    }, 250);
}

function bindSelectStoreButtons() {
    if (document.body.dataset.cfSelectStoreBound === "true") {
        return;
    }

    document.body.dataset.cfSelectStoreBound = "true";

    document.addEventListener(
        "click",
        function (event) {
            const button = event.target.closest(".js-select-store");
            if (!button || !button.closest(".contentlist.mappa_depositi")) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();

            const card = button.closest(".cf-location-card");
            const code = String(
                button.getAttribute("data-crm-id") ||
                    (card ? card.getAttribute("data-crm-id") : "") ||
                    ""
            ).trim();

            if (code) {
                selectDepositoCode(code);
            }

            scrollToPreventivo();

            afterPreventivoScroll(function () {
                if (!code) {
                    highlightDepositoSelect();
                    return;
                }

                if (selectDepositoCode(code)) {
                    highlightDepositoSelect();
                    return;
                }

                let tries = 0;
                const retry = window.setInterval(function () {
                    tries += 1;
                    if (selectDepositoCode(code) || tries >= 40) {
                        window.clearInterval(retry);
                        highlightDepositoSelect();
                    }
                }, 250);
            });
        },
        true
    );
}

function initLandingStoreSelect() {
    if (document.body.classList.contains("editing")) {
        return;
    }

    bindSelectStoreButtons();

    if (document.body.classList.contains("landing-one-col-map")) {
        return;
    }

    const cards = Array.prototype.slice.call(
        document.querySelectorAll(".contentlist.mappa_depositi .cf-location-card")
    );
    const cardCodes = allowedCodesFromCards(cards);

    fetch(branchJsonUrl(), { credentials: "same-origin" })
        .then(function (response) {
            if (!response.ok) {
                throw new Error(response.status + " " + response.statusText);
            }
            return response.json();
        })
        .then(function (data) {
            const records = data && data.records ? data.records : [];
            const area = areaFromPath(window.location.pathname, records);
            if (!area) {
                return;
            }

            let allowedCodes = codesForArea(records, area);
            if (!allowedCodes.length) {
                return;
            }

            if (cardCodes.length) {
                const fromCards = cardCodes.filter(function (code) {
                    return allowedCodes.indexOf(code) !== -1;
                });
                if (fromCards.length) {
                    allowedCodes = fromCards;
                }
            }

            watchDepositoSelect(allowedCodes);
        })
        .catch(function () {
            // Leave the full list if branch JSON is unavailable.
        });
}

export function initMappaDepositiMobileView() {
    const mq = window.matchMedia(MOBILE_MQ);
    const blocks = document.querySelectorAll(".contentlist.mappa_depositi");

    blocks.forEach(function (block) {
        initMappaDepositiBlock(block, mq);
    });

    initLandingFormAfterMap(mq);
    initLandingStoreSelect();
}
